import '../css/LoaderSupport.css';

const LoaderSupport = () => {
    return (
        <div className="loader-container">
            <div className="loader-circle">
                <div className="inner-circle"></div>
            </div>
            <p className="loader-text">Veuillez patienter lors du chargement...</p>
        </div>
    );
};

export default LoaderSupport;
